var _path, _path2, _path3, _path4, _path5, _path6, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeSection2Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1611 0H5.13885C2.30074 0 0 2.30074 0 5.13885V21.1976C0 24.0357 2.30074 26.3364 5.13885 26.3364H22.1611C24.9993 26.3364 27.3 24.0357 27.3 21.1976V5.13885C27.3 2.30074 24.9993 0 22.1611 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1152 3.85077H5.13966C3.72065 3.85077 2.57031 5.00111 2.57031 6.42012V20.0176C2.57031 21.4366 3.72065 22.587 5.13966 22.587H22.1152C23.5342 22.587 24.6845 21.4366 24.6845 20.0176V6.42012C24.6845 5.00111 23.5342 3.85077 22.1152 3.85077Z",
    fill: "#D2FA52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65625 5.35077V17.7049H19.5985V19.1941C19.5985 20.2446 20.4492 21.0952 21.4996 21.0952C22.5501 21.0952 23.4007 20.2446 23.4007 19.1941V5.35077H7.65625Z",
    fill: "white",
    stroke: "#003512",
    strokeWidth: 0.1236,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69141 14.8665H15.5369M9.69141 13.779H15.5369M9.69141 9.61047H15.5369M9.69141 8.52252H15.5369",
    stroke: "#003512",
    strokeWidth: 0.1236,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.598 19.1922V17.703H3.85547V19.1922C3.85547 20.2427 4.70627 21.0933 5.75672 21.0933H21.4991C20.4486 21.0933 19.598 20.2427 19.598 19.1922Z",
    fill: "white",
    stroke: "#003512",
    strokeWidth: 0.1236,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21790_24325",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 0,
    width: 16,
    height: 17
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2207 4.03496L23.3154 0.867859L26.5921 13.381L14.4975 16.5481L11.2207 4.03496Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21790_24325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4536 3.15359C14.3811 3.95819 12.5426 7.10099 13.3472 10.1736C14.1518 13.246 17.2947 15.0844 20.3672 14.2798C23.4396 13.4752 25.2782 10.3324 24.4736 7.25984C23.669 4.18739 20.526 2.34884 17.4536 3.15359ZM19.8459 12.2893C17.8733 12.8059 15.8568 11.6263 15.3402 9.65369C14.8236 7.68119 16.0032 5.66459 17.9759 5.14814C19.9485 4.63154 21.965 5.81114 22.4814 7.78364C22.998 9.75629 21.8186 11.7727 19.8459 12.2893Z",
    fill: "#14AA40",
    stroke: "#003512",
    strokeWidth: 0.1236,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4679 11.2918L19.4559 11.295C19.3235 11.3276 19.1861 11.3338 19.0513 11.3132C18.9166 11.2926 18.7873 11.2455 18.6708 11.1748L16.621 9.92517C16.5054 9.85485 16.4049 9.76242 16.3251 9.65318C16.2452 9.54394 16.1878 9.42003 16.1559 9.28854C16.124 9.15706 16.1184 9.02058 16.1394 8.88692C16.1603 8.75326 16.2074 8.62505 16.278 8.50962C16.3483 8.39407 16.4408 8.29352 16.55 8.21373C16.6593 8.13395 16.7832 8.07649 16.9146 8.04464C17.0461 8.01279 17.1826 8.00718 17.3162 8.02813C17.4499 8.04907 17.5781 8.09617 17.6935 8.16672L18.8514 8.87262L20.8521 5.49567C21.1414 5.00682 21.7741 4.84542 22.2628 5.13477C22.7517 5.42412 22.9131 6.05667 22.6239 6.54552L20.0916 10.8198C19.9531 11.0532 19.728 11.2223 19.4653 11.2903L19.4679 11.2918Z",
    fill: "#14AA40",
    stroke: "#003512",
    strokeWidth: 0.1236,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSection2Icon);
export default __webpack_public_path__ + "static/media/HomeSection2Icon.a51f7c5b101efe5dfd4e79a7fb137e49.svg";
export { ForwardRef as ReactComponent };